import type { IApplyingFinancingOfferRequestBody, IFinancingOfferFormValues } from '@/logic/financing/interfaces'

export const addCustomCommentToRequestBody = (
  body: IApplyingFinancingOfferRequestBody | IFinancingOfferFormValues,
  comment: string,
): IApplyingFinancingOfferRequestBody | IFinancingOfferFormValues => {
  return { ...body, comment }
}
